import { React } from 'react'
import { useNavigate } from 'react-router-dom';

function ResumeList({ resumesFiltered }) {
    
    const navigate = useNavigate();

    const resumeID = (id) => {
        navigate('/resumeEditor', {
            state: {
                resumeId: id,
            }
        });
    }


    return (
        <ul>
            {resumesFiltered && resumesFiltered.map((resume, index) => (
                <div className="MyCV" key={index}>
                    <div className="CV">
                        <h6>{resume.position}</h6>
                        <h6>{resume.creationDate.split('T')[0]}</h6>
                    </div>
                    <div className="ESD">
                        <button className="btnSCV-ESD" data-test="edit" resumeid={resume._id} onClick={() => resumeID(resume._id)}>Edit</button>
                    </div>
                </div>
            ))}
        </ul>
    )
}

export default ResumeList;